import LanguageCode from 'utils/enums/languageCode'
import apiClient from './apiClient'

/**
 * Get Banners
 * @param {object} payload
 * @returns 
 */
export const getBanners = async (languageCode: LanguageCode) => await apiClient.get('/api/banners', {languageCode: languageCode})
